import { Component, OnInit } from '@angular/core';
import { MessagingService } from '../../Services/messaging.service';
import { AuthConfig, AuthService, FCMNotificationActionEnum, FCMNotificationActionGroupEnum } from 'src/app/Services/auth.service';
import { Router } from '@angular/router';
@Component({
    selector: 'app-notification-lists',
    templateUrl: './notification-lists.component.html',
    styleUrls: ['./notification-lists.component.css'],
    standalone: false
})
export class NotificationListComponent implements OnInit {
  public notifications: any[] = [];
  public authConfig!: AuthConfig;
  public isLoading: boolean = false;
  public countUnreadNotificaion!: number;

  constructor(private authService: AuthService,
    private messagingService: MessagingService,
    private router: Router,


  ) { }
  ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    this.fetchNotifications(30);
    this.messagingService.getUnreadNotificationCount().subscribe(count => {
      this.countUnreadNotificaion = count;
      this.CountUnreadNotificaion();

    });


  }
  // Method to fetch notifications
  fetchNotifications(topN: number): void {
    this.isLoading = true;
    this.messagingService.fetchNotifications(topN).subscribe(
      (data) => {
        // Sort: Unread notifications (IsRead: false) appear firsat
        this.notifications = data.sort((a: any, b: any) => Number(a.IsRead) - Number(b.IsRead));
        console.log(this.notifications);
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching notifications:', error);
        this.isLoading = false;
      }
    );
  }


  public CountUnreadNotificaion(): void {
    this.messagingService.CountUnreadNotificaion().subscribe(
      (data) => {
        // Update the notifications array with the fetched data
        this.countUnreadNotificaion = data;
      },
      (error) => {
        console.error('Error fetching notifications:', error);
      }
    );
  }


  markasreadNotificaion(notification: any): void {
    this.messagingService.markasreadNotificaion(notification.EntityId).subscribe(
      (data) => {
        console.log(data)
        this.CountUnreadNotificaion()
      },
      (error) => {
        console.error('Error fetching notifications:', error);
      }
    );
  }



  public handleNotificationClick(notification: any) {
    this.markasreadNotificaion(notification)
    if (this.authConfig.IsArtist) {
      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Connection) {
        this.router.navigate([`/artists/connected-galleries`]);
      }

      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Proposal) {
        this.router.navigate([`/view-proposals`]);
      }
      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Consignment) {
        this.router.navigate([`/view-consignments`]);
      }
      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Product) {
        this.router.navigate([`/artists/artworks`]);
      }

    }
    if (this.authConfig.IsGallery) {
      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Connection) {
        this.router.navigate([`/connected-artists`]);
      }

      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Proposal) {
        this.router.navigate([`/view-proposals`]);
      }

      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Consignment) {
        this.router.navigate([`/view-consignments`]);
      }
      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Product) {
        this.router.navigate([`/galleries/gallery-products`]);
      }

    }
  }

}